export var getCustomizations = function (domain) { var _a; return (_a = domain === null || domain === void 0 ? void 0 : domain.filter(function (_a) {
    var channel = _a.channel;
    return channel === "WEB";
})) !== null && _a !== void 0 ? _a : null; };
//# sourceMappingURL=index.js.map